// Canonical risk-matrix palette: strong teal → pale teal → pale yellow → light pink → strong pink, ordered from
// lowest risk (index 0) to highest (index 4). Shared by the risk matrix heatmap and the per-level risk colors so
// they stay in sync.
export const riskPalette = ["#2CD5C4", "#C2EDE9", "#FFF79F", "#FE9FBC", "#F7447A"];

export const riskTextColor = "#32323C";
